import isString from 'lodash/isString'
import isNumber from 'lodash/isNumber'
import isObject from 'lodash/isObject'

const updateLinkParams = (urlLink, searchData, returnAsUrlObject = false) => {
  if (!isString(urlLink)) {
    console.error(`Property urlLink as "${JSON.stringify(urlLink)}" should be a string, but given ${typeof urlLink}`)

    return null
  }

  let url = null

  try {
    url = new URL(urlLink.trim())
  } catch (error) {
    console.error(error)

    return null
  }

  if (!url) {
    return null
  }

  if (!isObject(searchData) || Array.isArray(searchData)) {
    console.error(`Property searchData as "${JSON.stringify(searchData)}" should be a string, but given ${typeof searchData}`)

    return urlLink
  }

  Object.entries(searchData).forEach(([key, value]) => {
    if (!key) {
      throw new Error('key is required for searchData')
    }

    const isAvailableValue = (value) => isString(value) || isNumber(value) || (Array.isArray(value) && value.length)

    if (value) {
      if (isAvailableValue(value)) {
        url.searchParams.set(key, String(value))
      } else {
        // TODO: create logger
        console.error(`Value as "${JSON.stringify(value)}" should be a string. Expected ${typeof value} type for searchData`)
      }
    } else {
      url.searchParams.delete(key)
    }
  })

  if (returnAsUrlObject) {
    return url
  }

  return url.toString()
}

export default updateLinkParams
